import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
} from "@mui/material";
// hooks
import useResponsive from '../../../hooks/useResponsive';
import useLocalStorage from '../../../hooks/useLocalStorage';


export default function TimeMatchDialog({ isOpen, closeDialog}) {
  const smUp = useResponsive('up', 'sm');
  const [dnd, setDnd] = useLocalStorage('dioCrewTimeMatchDialog', false);

  const close = () => {
    setDnd(true);
    closeDialog();
  }

  return (
    <Dialog open={isOpen} onClose={closeDialog} fullWidth maxWidth="sm">
      <DialogContent sx={{ my: { xs: 0, sm: 1 }, p: { xs: 3, sm : 4 }  }}>
        <Typography variant="h5" sx={{ mb: { xs : 3, sm : 4 } }}>
          여러 회사와 동시에 일할 수 있어요! 🎉
        </Typography>
        <Typography variant="h6" gutterBottom>
          ⏰ 주 20시간 안에서 자유롭게 일해요
        </Typography>
        <Typography sx={{ mb: 4, color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          A회사에서 10시간, B회사에서 5시간, C회사에서 5시간 일할 수 있어요.
        </Typography>
        <Typography variant="h6" gutterBottom>
          ✅ 회사마다 계약 시간을 관리할 수 있어요
        </Typography>
        <Typography sx={{ mb: 4, color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          매칭 페이지에서 계약 시간 확인할 수 있어요.
        </Typography>
        <Typography variant="h6" gutterBottom>
          🤝 매칭을 원할 때 쉽게 켜고 끌 수 있어요
        </Typography>
        <Typography sx={{ color: 'text.secondary' }} variant={smUp ? "body1" : "body2"}>
          남은 시간이 있으면 자동으로 다른 회사와 매칭이 돼요. 더 이상 매칭을 원하지 않으면 설정을 off 해주세요.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button
          sx={{ px: 4 }}
          fullWidth={smUp ? false : true}
          onClick={close}
          variant="contained"
          size="large"
        >
          확인했어요
        </Button>
      </DialogActions>
    </Dialog>
  )
}